module.exports = __webpack_public_path__ + "media/images/client_certificate_selection/certificates_in_edge-1b7f75e6b85aead74665f881851d319e.png";